import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
const Page = lazy(
  () => import("@/features/financial/page-client"),
);
export const Route = createFileRoute("/_authed/staff/sub/financial")(
  {
    component: () => (
      <Suspense fallback={null}>
        <Page />
      </Suspense>
    ),
  },
);
